module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// ../~/htmlparser2/~/entities/maps/xml.json
// module id = 1491
// module chunks = 1